const Accordion = {
  data () {
    return {
      activeChild: null
    }
  },
  methods: {
    handleToggle: function(id) {
      this.activeChild = (this.activeChild === id)
        ? null
        : id
    },
    startTransition: function(el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function(el) {
      el.style.height = ''
    },
  },
  created () {
    bus.$on('accordion_toggle', id => {
      this.handleToggle(id)
    })
  }
}


export default Accordion
